import { ExclamationCircleOutlined } from '@ant-design/icons';
import { Divider, Modal } from 'antd';
import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import { Column, ContentRow, InfoItem, Label, SectionTitle, Value } from './styles';

function AlertDetail({ selectedAlert, alertModalVisible, handleCloseAlertModal }) {
	const [breachDuration, setBreachDuration] = useState('');

	// eslint-disable-next-line consistent-return
	useEffect(() => {
		if (selectedAlert && selectedAlert.created_at) {
			const updateDuration = () => {
				const [datePart, timePart] = selectedAlert.created_at.split(' ');
				const [month, day, year] = datePart.split('/');
				const [createdHours, createdMinutes, createdSeconds] = timePart.split(':');

				const createdTime = Date.UTC(
					year,
					month - 1,
					day,
					createdHours,
					createdMinutes,
					createdSeconds
				);
				const currentTime = Date.now();
				const durationMs = currentTime - createdTime;

				const totalMinutes = Math.floor(durationMs / (1000 * 60));
				const hours = Math.floor(totalMinutes / 60);
				const minutes = totalMinutes % 60;

				setBreachDuration(`${hours}hr ${minutes}min`);
			};

			updateDuration();
			const intervalId = setInterval(updateDuration, 1000);

			return () => clearInterval(intervalId);
		}
	}, [selectedAlert]);

	return (
		<Modal
			title={
				<div
					style={{
						color: '#FF4D4F',
						display: 'flex',
						alignItems: 'center',
						justifyContent: 'center',
					}}
				>
					<ExclamationCircleOutlined style={{ marginRight: '12px', fontSize: '20px' }} />
					<span style={{ fontSize: '18px', fontWeight: '600' }}>BREACH</span>
				</div>
			}
			open={alertModalVisible}
			onCancel={handleCloseAlertModal}
			footer={null}
			width={900}
		>
			{selectedAlert && (
				<div style={{ padding: '8px 4px' }}>
					<ContentRow>
						<Column>
							<SectionTitle>Vehicle No. {selectedAlert.vehicle_number}</SectionTitle>
							<InfoItem>
								<Label>Driver Name:</Label>
								<Value>
									{selectedAlert.driver_name} ({selectedAlert.driver_number})
								</Value>
							</InfoItem>
							<InfoItem>
								<Label>Vendor Name:</Label>
								<Value>
									{selectedAlert.vendor_name} ({selectedAlert.vendor_number})
								</Value>
							</InfoItem>
						</Column>
						<Column>
							<InfoItem>
								<SectionTitle style={{ color: '#FF4D4F' }}>
									Breach: High Temperature {selectedAlert.temperature}°C
								</SectionTitle>
							</InfoItem>
							<InfoItem>
								<Label>Breach Duration:</Label>
								<Value>{breachDuration}</Value>
							</InfoItem>
						</Column>
					</ContentRow>

					<Divider style={{ margin: '8px 0 24px' }} />

					<ContentRow>
						<Column>
							<SectionTitle>POC Information</SectionTitle>
							<InfoItem>
								<Label>Hub:</Label>
								<Value>{selectedAlert.hub_name}</Value>
							</InfoItem>
							<InfoItem>
								<Label>City Manager:</Label>
								<Value>
									{selectedAlert.city_manager_name} (
									{selectedAlert.city_manager_number})
								</Value>
							</InfoItem>
						</Column>
						<Column>
							<SectionTitle>Monitor Range</SectionTitle>
							<InfoItem>
								<Label>Temperature:</Label>
								<Value>
									{parseFloat(selectedAlert.minimum_temperature).toString()}°C -{' '}
									{parseFloat(selectedAlert.maximum_temperature).toString()}°C
								</Value>
							</InfoItem>
						</Column>
					</ContentRow>
				</div>
			)}
		</Modal>
	);
}

AlertDetail.propTypes = {
	selectedAlert: PropTypes.object,
	alertModalVisible: PropTypes.bool.isRequired,
	handleCloseAlertModal: PropTypes.func.isRequired,
};

export default AlertDetail;
